import { addEventListener } from '../utils/dom';
import { useCallback, useEffect, useState } from 'react';
/** `getBoundingClientRect` */
export function useDOMRect(_a) {
    var ref = _a.ref, isDisabled = _a.isDisabled;
    var _b = useState(), rect = _b[0], setRect = _b[1];
    var updatePosition = useCallback(function () {
        if (!ref.current) {
            return;
        }
        setRect(ref.current.getBoundingClientRect());
    }, [ref]);
    useEffect(function () {
        var element = ref.current;
        if (isDisabled) {
            return undefined;
        }
        updatePosition();
        var scrollListener = addEventListener(window, 'scroll', updatePosition);
        var resizeListener = addEventListener(window, 'resize', updatePosition);
        var resizeObserver;
        if (element) {
            resizeObserver = new ResizeObserver(updatePosition);
            resizeObserver.observe(element);
        }
        return function () {
            scrollListener();
            resizeListener();
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
        };
    }, [ref, isDisabled, updatePosition]);
    return rect;
}
//# sourceMappingURL=useDOMRect.js.map